import { render, staticRenderFns } from "./EditRelation.vue?vue&type=template&id=c1a0beb4&scoped=true&"
import script from "./EditRelation.vue?vue&type=script&lang=js&"
export * from "./EditRelation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1a0beb4",
  null
  
)

export default component.exports